import { useEffect, useState } from 'react'
import { Typography, Box } from '@material-ui/core'
import _ from 'lodash'
import { useHistory } from 'react-router-dom'
import PageTitleInstaller from '../../components/PageTitleInstaller'
import Footer from '../../components/Footer'
import Header from '../../components/Header'
import { ENPHASE_INSTALLER } from '../../components/Header/constants'
import TableOutline from '../../components/TableOutline'
import Card from '../../components/Card'
import {
  systemsTableHeadings,
  DEFAULT_SYSTEM_PAGE_SIZE,
  DEFAULT_SYSTEM_PAGE_NO,
  DEFAULT_SYSTEM_LIST,
  ALL,
  statusMapper
} from './constants'
import urlStrings from '../../utils/urlStrings'
import axios from 'axios'
import Loader from '../../utils/loader'
import {
  getCompanyName,
  getIsInstaller,
  getSessionToken,
} from '../../utils/helper'
import { useStyles } from './styles'
import moment from 'moment'
import { defaultTimezone } from '../../utils/momentTimezones'
import { applicationService } from '../../Services/ApplicationService'
import Process from './Process'
const InstallerHomePage = () => {
  const classes = useStyles()
  const history = useHistory()
  const [systemPageNo, setSystemPageNo] = useState(DEFAULT_SYSTEM_PAGE_NO)
  const [systemPageSize, setSystemPageSize] = useState(DEFAULT_SYSTEM_PAGE_SIZE)
  const [systemsList, setSystemsList] = useState(DEFAULT_SYSTEM_LIST)
  const [totalCount, setTotalCount] = useState(0)
  const [selected, setSelected] = useState(false)
  const [headingStatus, setHeadingStatus] = useState(ALL)
  const [workflowModal, setWorkflowModal] = useState(false)
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    if (_.isEmpty(getSessionToken())) history.push('/')
    else if (
      _.isEmpty(getIsInstaller()) === false &&
      getIsInstaller() === 'false'
    )
      history.push('/customersupport')
    setLoading(true)
    applicationService.getApplicationsPaginated(systemPageSize, systemPageNo > 0 ? systemPageNo : 0, headingStatus ? statusMapper[headingStatus] : '')
      .then((data) => {
        setTotalCount(data?.total_count)
        const siteList = []
        const applications = data?.applications
        applications?.map((site, index) => {
          const siteId = site.site_id
          const name = site.name
          const committedkW = site.dispatch_capacity
          const installerName = site.installer_name
          const siteStatus = site.status
          const timestamp = site.last_modified_date
          siteList.push([siteId, name, committedkW, installerName, siteStatus, timestamp])
        })
        setSystemsList(siteList)
        setLoading(false)
      })
      .catch((error) => {
        setLoading(false)
      })
  }, [systemPageSize, systemPageNo, headingStatus])

  const handleDropdownChange = (value) => {
    setSystemPageNo(DEFAULT_SYSTEM_PAGE_NO)
    setHeadingStatus(value)
  }

  const getSystemData = () => {
    const systemDetails = []
    systemsList.forEach((obj) => {
      let tableObj = [
        {
          id: 'enphaseSiteId',
          value: obj[0],
        },
        {
          id: 'homeOwnerFullName',
          value: obj[1],
        },
        {
          id: 'committedKW',
          value: obj[2],
        },
        {
          id: 'installerName',
          value: obj[3],
        },
        {
          id: 'status',
          value: obj[4],
        },
        {
          id: 'timestamp',
          value: moment.tz(obj[5], defaultTimezone).format('MMMM DD,YYYY h:mm A zz'),
        },
      ]
      systemDetails.push(tableObj)
    })

    return systemDetails
  }
  const handleChangeRowsPerPage = (value) => {
    setSystemPageSize(value)
    setSystemPageNo(DEFAULT_SYSTEM_PAGE_NO)
  }
  const renderSystemContent = () => {
    const tableData = getSystemData()
    return (
      <Box>
        <TableOutline
          tableHeadings={systemsTableHeadings}
          tableData={tableData}
          totalElement={totalCount}
          page={systemPageNo}
          rowsPerPage={systemPageSize}
          handleDropdownChange={handleDropdownChange}
          selectedStatus={headingStatus}
          handleChangePage={setSystemPageNo}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          pagination
        />
      </Box>
    )
  }
  return (
    <>
      <Loader loading={loading}></Loader>
      <Header
        isSignedIn={true}
        role={ENPHASE_INSTALLER}
        setLoading={setLoading}
        selected={selected}
        setSelected={setSelected}
      ></Header>
      <Typography
        variant="h3"
        style={{
          fontWeight: 'bold',
          color: '#707070',
          padding: '25px 0px 0px 41px',
        }}
      >
        Welcome {getCompanyName()}
      </Typography>
      <PageTitleInstaller
        heading="Application Tracker"
        hasNewApplicationButton={true}
        hasDownloadApplicationFormButton={true}
        setWorkflowModal={setWorkflowModal}
      ></PageTitleInstaller>
      {workflowModal && <Process open={workflowModal} handleClose={() => setWorkflowModal(false)} />}
      <Card className={classes.cardWrapper} children={renderSystemContent()} />

      <Footer></Footer>
    </>
  )
}
export default InstallerHomePage
